/**
 * Единый словарь пользовательских текстов панели администратора региона
 * (ТЗ §8.1: «тексты — в файлах перевода, без захардкоженных строк в компонентах»).
 */
export const ru = {
  app: {
    name: 'ПромТурТверь',
    panel: 'Администратор региона',
    tagline: 'Заводы и люди',
  },
  nav: {
    analytics: 'Аналитика',
    moderation: 'Модерация',
    dictionaries: 'Справочники',
    roles: 'Роли',
    requests: 'Заявки предприятий',
    exports: 'Выгрузка отчётов',
    registry: 'Госреестр',
    notifications: 'Уведомления',
    audit: 'Журнал аудита',
    sections: 'Разделы',
    menu: 'Меню',
    close: 'Закрыть',
    logout: 'Выйти',
  },
  common: {
    loading: 'Загружаем данные…',
    empty: 'Пока нет данных',
    emptyDescription: 'Данные появятся после первого действия.',
    error: 'Не удалось загрузить данные',
    errorDescription: 'Проверьте соединение и повторите попытку.',
    retry: 'Повторить',
    refresh: 'Обновить',
    more: 'Загрузить ещё',
    save: 'Сохранить',
    saving: 'Сохраняем…',
    cancel: 'Отмена',
    create: 'Создать',
    edit: 'Изменить',
    delete: 'Удалить',
    close: 'Закрыть',
    apply: 'Применить',
    date: 'Дата',
    time: 'Время',
    all: 'Все',
    yes: 'Да',
    no: 'Нет',
    notSpecified: 'Не указано',
    unknownError: 'Неизвестная ошибка',
    networkError: 'Нет связи с сервером. Проверьте интернет.',
    from: 'С',
    to: 'По',
    period: 'Период',
    status: 'Статус',
    actions: 'Действия',
    name: 'Наименование',
    address: 'Адрес',
    phone: 'Телефон',
    email: 'E-mail',
    district: 'Район',
    category: 'Категория',
    user: 'Пользователь',
    object: 'Объект',
    role: 'Роль',
    created: 'Создано',
    reason: 'Причина',
    reasonRequired: 'Укажите причину — она попадёт в журнал',
    noPii: 'Аналитика обезличенная: персональные данные не выводятся',
  },
  login: {
    title: 'Вход в панель администратора',
    subtitle: 'Министерство туризма Тверской области · сквозная аналитика и модерация',
    email: 'E-mail',
    emailPlaceholder: 'admin@mintour.tver.ru',
    password: 'Пароль',
    passwordHint: 'Не менее 12 символов',
    submit: 'Войти',
    submitting: 'Входим…',
    twoFactorTitle: 'Подтверждение входа',
    twoFactorHint:
      'Для роли «Администратор региона» обязательна двухфакторная аутентификация. Введите код из приложения-аутентификатора.',
    twoFactorCode: 'Код подтверждения',
    twoFactorSubmit: 'Подтвердить',
    twoFactorBack: 'Вернуться ко входу',
    errorInvalid: 'Неверный e-mail или пароль.',
    errorTwoFactor: 'Неверный или просроченный код подтверждения.',
    errorNetwork: 'Нет связи с сервером. Проверьте интернет.',
    errorBlocked: 'Учётная запись заблокирована.',
    errorForbidden: 'У этой учётной записи нет прав администратора региона.',
    support: 'Доступ выдаёт администратор Платформы.',
  },
  analytics: {
    title: 'Сквозная аналитика',
    subtitle: 'Разрезы: объект, район, категория, период, канал, возраст, тип билета, повторность',
    filters: 'Фильтры',
    objectFilter: 'Объект',
    districtFilter: 'Район',
    categoryFilter: 'Категория производства',
    channelFilter: 'Канал привлечения',
    ageFilter: 'Возраст гостя',
    ticketFilter: 'Тип билета',
    repeatFilter: 'Повторность визита',
    repeatYes: 'Повторный',
    repeatNo: 'Первый',
    reset: 'Сбросить фильтры',
    visits: 'Посещения',
    bookings: 'Брони',
    cancellations: 'Отмены',
    cancellationRate: 'Доля отмен',
    averageCheck: 'Средний чек',
    repeatRate: 'Доля повторных',
    byDistrict: 'По районам',
    byCategory: 'По категориям',
    byAge: 'По возрасту',
    byTicketType: 'По типам билетов',
    byChannel: 'По каналам привлечения',
    noData: 'За выбранный период данных нет',
  },
  moderation: {
    title: 'Модерация объектов',
    subtitle: 'Приём, проверка, публикация и снятие с публикации',
    filterStatus: 'Статус карточки',
    object: 'Объект',
    publish: 'Опубликовать',
    unpublish: 'Снять с публикации',
    reject: 'Отклонить',
    rejectReason: 'Причина отклонения',
    rejectHint: 'Причина фиксируется в журнале аудита',
    published: 'Опубликован',
    unpublished: 'Снят с публикации',
    statusDraft: 'Черновик',
    statusOnReview: 'На модерации',
    statusPublished: 'Опубликован',
    statusRejected: 'Отклонён',
    statusArchived: 'В архиве',
    empty: 'Карточек с таким статусом нет',
  },
  dictionaries: {
    title: 'Справочники',
    subtitle: 'Районы, категории, типы билетов, тексты ТБ и промо-блоки',
    tabDistricts: 'Районы',
    tabCategories: 'Категории производств',
    tabTicketTypes: 'Типы билетов',
    tabSafety: 'Тексты требований ТБ',
    tabPromo: 'Промо-блоки',
    add: 'Добавить',
    edit: 'Редактировать',
    name: 'Наименование',
    code: 'Код',
    description: 'Описание',
    active: 'Активен',
    inactive: 'Неактивен',
    blockTitle: 'Заголовок',
    text: 'Текст',
    link: 'Ссылка',
    showFrom: 'Показывать с',
    showTo: 'Показывать по',
    empty: 'Справочник пуст',
  },
  roles: {
    title: 'Роли и доступ',
    subtitle: 'Назначение модераторов объектов, снятие прав и блокировка учётных записей',
    assignModerator: 'Назначить модератором',
    revoke: 'Снять права',
    block: 'Заблокировать',
    unblock: 'Разблокировать',
    enterprise: 'Предприятие',
    roleObjectModerator: 'Представитель предприятия',
    roleRegionAdmin: 'Администратор региона',
    rolePlatformOperator: 'Оператор платформы',
    roleGuest: 'Посетитель',
    blocked: 'Заблокирован',
    active: 'Активен',
    empty: 'Пользователей не найдено',
  },
  requests: {
    title: 'Заявки предприятий',
    subtitle:
      'Заявки на подключение: подтвердите представителя и назначьте его модератором своего объекта',
    legalName: 'Название предприятия',
    contact: 'Контактное лицо',
    inn: 'ИНН',
    slotsPerWeek: 'Готовность выделять слотов',
    message: 'Комментарий',
    createdAt: 'Поступила',
    kindOnboarding: 'Подключение предприятия',
    kindBusinessVisit: 'Деловой визит',
    statusNew: 'Новая',
    statusInProgress: 'В работе',
    statusAnswered: 'Отвечена',
    statusRejected: 'Отклонена',
    assignModerator: 'Назначить модератором',
    assigned: 'Представитель назначен модератором предприятия',
    enterprise: 'Предприятие',
    enterpriseSelect: 'Выберите предприятие',
    enterpriseManual: 'Указать идентификатор вручную',
    enterpriseManualId: 'Идентификатор предприятия',
    enterpriseEmpty: 'В справочнике нет предприятий — укажите идентификатор вручную',
    noUser: 'Учётная запись не создана — назначить модератора нельзя',
    empty: 'Заявок пока нет',
    emptyDescription: 'Заявки на подключение поступают из формы регистрации предприятия.',
    errorAssign: 'Не удалось назначить модератора. Проверьте предприятие и повторите попытку.',
  },
  exports: {
    title: 'Выгрузка отчётов',
    subtitle: 'XLSX и CSV в UTF-8 с BOM; выгрузка фиксируется в журнале',
    reportType: 'Тип отчёта',
    reportVisits: 'Посещаемость',
    reportRevenue: 'Выручка',
    reportBookings: 'Брони и отмены',
    reportDistricts: 'Структура по районам',
    reportCategories: 'Структура по категориям',
    format: 'Формат',
    formatCsv: 'CSV',
    formatXlsx: 'XLSX',
    download: 'Выгрузить',
    downloaded: 'Файл сформирован. Выгрузка записана в журнал.',
    journal: 'Журнал выгрузок',
    journalUser: 'Пользователь',
    journalFormat: 'Формат',
    journalRows: 'Строк',
    journalTime: 'Время выгрузки',
    journalEmpty: 'Выгрузок пока не было',
    serverExport: 'Выгрузка на сервере',
    serverExportHint: 'Серверная выгрузка — по утверждённой форме Министерства туризма (FR-OBS-04).',
    serverExportLink: 'Открыть файл отчёта',
  },
  registry: {
    title: 'Готовность карточек к госреестру',
    subtitle: 'Предпросмотр паспорта объекта в настраиваемом шаблоне без привязки к формату',
    selectObject: 'Объект',
    template: 'Шаблон паспорта',
    templateHint: 'Формат госреестра определяется на этапе 2 — шаблон настраивается вручную',
    field: 'Поле паспорта',
    addField: 'Добавить поле',
    moveUp: 'Выше',
    moveDown: 'Ниже',
    removeField: 'Убрать',
    preview: 'Предпросмотр паспорта',
    completeness: 'Заполненность карточки',
    missingFields: 'Не заполнено',
    exportCsv: 'Выгрузить паспорт в CSV',
    empty: 'Объект не выбран',
    defaultTemplateName: 'Паспорт объекта',
    defaultFields: {
      name: 'Наименование объекта',
      legalName: 'Юридическое наименование',
      districtName: 'Район',
      address: 'Адрес',
      category: 'Категория производства',
      foundedYear: 'Год основания',
      description: 'Описание',
      contactPhone: 'Телефон',
      contactEmail: 'E-mail',
      website: 'Сайт',
    },
  },
  notifications: {
    title: 'Шаблоны уведомлений',
    subtitle: 'Редактирование текстов и задержки отправки по каждому событию',
    event: 'Событие',
    delay: 'Задержка отправки, мин',
    mandatory: 'Служебное уведомление',
    mandatoryHint: 'Служебные уведомления по действующей брони отключению не подлежат (FR-NTF-04)',
    body: 'Текст уведомления',
    saveAll: 'Сохранить все шаблоны',
    saved: 'Шаблоны сохранены',
    empty: 'Шаблонов нет',
  },
  audit: {
    title: 'Журнал аудита',
    subtitle: 'Кто, что и когда — с привязкой к объекту',
    actor: 'Пользователь',
    action: 'Действие',
    entity: 'Объект',
    time: 'Время',
    meta: 'Детали',
    empty: 'Записей журнала нет',
  },
  categories: {
    machine_building: 'Машиностроение',
    folk_crafts: 'Народные промыслы',
    food_industry: 'Пищевая промышленность',
    it_and_innovation: 'IT и инновации',
    energy: 'Энергетика',
    chemical_industry: 'Химическая промышленность',
    other: 'Другое',
  },
  ticketTypes: {
    individual: 'Индивидуальный',
    group: 'Групповой (от 10 человек)',
    discounted: 'Льготный',
  },
} as const;

export type RuDictionary = typeof ru;
